import styled from "styled-components";
import { colors } from "../../../lib/colors";
import { COMBINATION_STYLED_PROPS } from "./interface";

export const CombinationContainer = styled.div`
  padding: 30px 0 10px;
`;

export const Row = styled.div<COMBINATION_STYLED_PROPS>`
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  color: ${colors.secondaryBackground};
  animation: ${({ isWin }) => isWin && "flickle"};
  animation-duration: 250ms;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  margin-bottom: 9px;
  p:last-child {
    font-family: "GT America, regularN";
  }

  @keyframes flickle {
    0% {
      color: ${colors.secondaryBackground};
    }
    33% {
      color: ${colors.secondary};
    }
    66% {
      color: ${colors.secondaryBackground};
    }
    100% {
      color: ${colors.secondary};
    }
  }
`;
